import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useState } from "react";

// Pages
import Home from "./pages/Home";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import BookingSuccess from "./pages/BookingSuccess";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import Dashboard from "./pages/Dashboard";

// Components
import Navbar from "./components/Navbar";
import NoiseOverlay from "./components/NoiseOverlay";
import WaitlistModal from "./components/WaitlistModal";
import MobileBottomNav from "./components/MobileBottomNav";
import PWAInstallPrompt from "./components/PWAInstallPrompt";

// Contexts - Audio Singleton Controller
import { AudioProvider } from "./contexts/AudioContext";

// Mobile-only styles (desktop unaffected via media queries)
import "./styles/mobile.css";

function App() {
  const [showWaitlist, setShowWaitlist] = useState(false);

  return (
    <div className="App min-h-screen bg-background">
      <NoiseOverlay />
      <BrowserRouter>
        <AudioProvider>
          <Navbar onSignUpClick={() => setShowWaitlist(true)} />
          <Routes>
            <Route path="/" element={<Home onSignUpClick={() => setShowWaitlist(true)} />} />
            <Route path="/events" element={<Events onSignUpClick={() => setShowWaitlist(true)} />} />
            <Route path="/experiences" element={<Events onSignUpClick={() => setShowWaitlist(true)} />} />
            <Route path="/events/:eventId" element={<EventDetail onSignUpClick={() => setShowWaitlist(true)} />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/booking-success" element={<BookingSuccess />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="*" element={<Home onSignUpClick={() => setShowWaitlist(true)} />} />
          </Routes>
          {/* Mobile Bottom Navigation - Hidden on desktop via CSS */}
          <MobileBottomNav />
          {/* PWA Install Prompt - Shows on mobile after delay */}
          <PWAInstallPrompt />
        </AudioProvider>
      </BrowserRouter>
      <WaitlistModal isOpen={showWaitlist} onClose={() => setShowWaitlist(false)} />
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid #333',
            color: '#EDEDED',
            fontFamily: 'Outfit, sans-serif'
          }
        }}
      />
    </div>
  );
}

export default App;
